import Api from "@/services/Api";

export default {
  async get(resource: any) {
    return Api().get(`central/${resource}`)
  },
};

